import FronteggClient from "../FronteggClient";

export async function getUsersByTenantId(tenantId: string) {
  const response = await FronteggClient.get(`identity/resources/users/v3`, {
    params: {
      _limit: 99999,
    },
    headers: {
      "frontegg-tenant-id": tenantId,
    },
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
